module.exports = __webpack_public_path__ + "img/magic_wand_white.7e729101.png";